<template>
  <RouterView name="header" />
  <RouterView v-slot="{ Component, route }">
    <Transition name="sjp-route" mode="out-in">
      <div v-if="Component" :key="route.path" class="sjp-route-view">
        <component :is="Component" />
      </div>
    </Transition>
  </RouterView>
  <RouterView name="footer" />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.question.front span {
  font-size: 60px;
}
.question.back span:nth-child(1) {
  font-size: 28px;
}
@import "@/sass/v2/HomePage.scss";
</style>
